import { Pipe, PipeTransform } from '@angular/core'
import { IQuestion, QuestionType } from 'shared-lib'

@Pipe({
  name: 'questionTypeIcon',
})
export class QuestionTypeIconPipe implements PipeTransform {
  transform(question: IQuestion | null): string {
    if (!question) return ''

    switch (question.type) {
      case QuestionType.Essay:
        return 'article'
      case QuestionType.Video:
        return 'videocam'
      case QuestionType.EssayOrVideo:
        return 'account_circle'
      default:
        return ''
    }
  }
}
